module.exports = __webpack_public_path__ + "static/media/55.b912b9cf.jpeg";